// extracted by mini-css-extract-plugin
export default {"button":"CloseMenuButton__button--1OZiY"};